
<div class="container">

  <div class="form-row" style="height: 100px;">


  </div>
  <div class="form-row" style="height: 100px;">


  </div>
<div class="form-row">

  <div class="col-lg-12 col-sm-12 col-md-12" style="text-align: center;"> 


    <span style="font-size:50px; font-weight: bold; text-align: center;">{{'thankyou.TranslationSection.text1' | translate}}</span>
 


  </div>

</div>


<div class="form-row" style="height: 20px;">


</div>

<div class="form-row">

  <div class="col-lg-12 col-sm-12 col-md-12" style="text-align: center;">


    <img width="55" height="55" src="../../../../../assets/images/check4.jpg" alt="../../../../../assets/images/images.png"/> 



  </div>

</div>


<div class="form-row" style="height: 20px;">


</div>



<div class="form-row">

  <div class="col-lg-12 col-sm-12 col-md-12" style="text-align: center;"> 

      


<h1>
    <span style="text-align: center;font-size:medium;">{{'thankyou.TranslationSection.text2' | translate}}<br>  {{'thankyou.TranslationSection.text3' | translate}}<br>
      {{'thankyou.TranslationSection.text4' | translate}} {{branchphone}}</span>
  </h1>


  </div>

</div>



</div>

  